import { Translation } from 'cng-common/features/translations'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import { IPartnerDocumentSection } from '../../../../lib/documentsAndLinks'
import { CockpitSectionHeader } from '../../../components/cockpitSectionHeader'
import { useCockpitEltCreationPeriod } from '../../hooks/useCockpitEltCreationPeriod'
import { CockpitDocumentLinks } from '../cockpitDocumentLinks/CockpitDocumentLinks'
import { EltCreateControls } from '../eltCreateControls/EltCreateControls'
import { EltDocumentsTable } from '../eltDocumentsList/EltDocumentsTable'
import { QbrCreateControls } from '../qbrCreateControls/QbrCreateControls'
import { QbrDocumentsTable } from '../qbrDocumentsList/QbrDocumentsTable'

import styles from './PartnerDocumentsSection.module.scss'

interface IPartnerDocumentsSectionProps {
  section: IPartnerDocumentSection
  readOnly: boolean
  showHeader: boolean
  documentType?: 'elt' | 'qbr'
  showCreateControls?: boolean
  showLinks: boolean
}

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks

export const PartnerDocumentsSection = ({
  section,
  readOnly,
  showHeader,
  showLinks,
  showCreateControls = true,
  documentType,
}: IPartnerDocumentsSectionProps) => {
  const { fYear, fQuarter } = useCockpitEltCreationPeriod()

  return (
    <div className={styles.root}>
      {showHeader && (
        <div className={styles.header}>
          <span className={styles.partnerName}>{section.partnerName}</span>
          <span className={styles.partnerId}>{section.partnerId}</span>
        </div>
      )}

      {documentType !== 'qbr' && (
        <div className={styles.typeGroup}>
          {readOnly || !showCreateControls ? (
            <CockpitSectionHeader>
              <Translation span text={KEYS.sectionElt} /> — FY{fYear} Q{fQuarter}
            </CockpitSectionHeader>
          ) : (
            <EltCreateControls partnerId={section.partnerId} documents={section.eltDocuments} />
          )}
          <EltDocumentsTable
            partnerId={section.partnerId}
            documents={section.eltDocuments}
            readOnly={readOnly}
          />
        </div>
      )}

      {documentType !== 'elt' && (
        <div className={styles.typeGroup}>
          {readOnly || !showCreateControls ? (
            <CockpitSectionHeader>
              <Translation span text={KEYS.sectionQbr} />
            </CockpitSectionHeader>
          ) : (
            <QbrCreateControls partnerId={section.partnerId} rtm={section.rtm} />
          )}
          <QbrDocumentsTable
            partnerId={section.partnerId}
            documents={section.qbrDocuments}
            readOnly={readOnly}
          />
        </div>
      )}

      {showLinks && (
        <div className={styles.typeGroup}>
          <CockpitSectionHeader>
            <Translation span text={KEYS.sectionLinks} />
          </CockpitSectionHeader>
          <CockpitDocumentLinks partnerId={section.partnerId} partnerRtm={section.rtm} />
        </div>
      )}
    </div>
  )
}

PartnerDocumentsSection.displayName = 'PartnerDocumentsSection'
